import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const withProgressBar = async <T = void>(
  {
    editorSdkProxy,
    title,
    hideNumericIndicator,
    stepTitle,
  }: {
    editorSdkProxy: EditorSDK
    title: string
    stepTitle?: string
    hideNumericIndicator?: boolean
  },
  fn: () => Promise<T>,
) => {
  await editorSdkProxy.editor.openProgressBar({
    title,
    totalSteps: 1,
    stepTitle,
    hideNumericIndicator,
  })

  try {
    const result = await fn()

    await editorSdkProxy.editor.updateProgressBar({
      currentStep: 1,
    })

    return result
  } finally {
    await editorSdkProxy.editor.closeProgressBar({})
  }
}
